import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-enterprise';
import { LoggingService } from 'src/app/services/logging.service';
import { FormTasksEntryComponent } from '../form-tasks-entry/form-tasks-entry.component'
import 'chosen-js';
import * as dayjs from 'dayjs';
import { AppModule } from '../../../../app.module';
import { HourglassService } from 'src/app/services/hourglass.service';


@Component({
  selector: 'app-tab-tasks-grid',
  templateUrl: './tab-tasks-grid.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabTasksGridComponent implements OnInit {
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  @ViewChild(FormTasksEntryComponent) taskEditor!: FormTasksEntryComponent;
  token!: string;
  gridApi!: GridApi<any>;
  impersonateUser = "";
  taskForm: any = {
    taskId:0,
    taskName: "",
    taskDescription: "",
    taskActive: -1,
    taskStatus:-1,
    category: "",
    clients: [],
    assignees: []
  };
  lastCol = "";
  listEmployees: any[] = [];
  listTasks: any[] = [];
  rowData: any[] = [];
  columnDefs: ColDef[] = [];
  editedRows: Set<number> = new Set();
  errorMessage = "";
  pageSize = true;
  rowSelection: any = "single";
  saveMode = "add";
  searchText = "";
  showModal = "none";
  tableName: any;
  userID: any = sessionStorage.getItem("wOSAuthUser");

  constructor(
    private hourglassService: HourglassService,
    private route: ActivatedRoute,
    private loggingService: LoggingService,
    private appModule: AppModule
  ) { }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    //this.getUXData(this.userID, 'tasks', this.token);
  }

  ngOnInit(): void {
    const i = 0;
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;
  }

  addTask() {
    $('#taskModal .modal-title').html("<i class='fas fa-fw fa-lg fa-check me-1'></i>Add Task");
    this.taskEditor.clearAddTask();
    //this.taskEditor.loadFromAddButton(null);
    this.toggleModal('show');
  }

  toggleModal(mode: string) {
    this.showModal = (mode == 'show') ? "show" : "hide";
    ($('#taskModal') as any).modal(this.showModal);
    if (this.showModal == "hide") { 
      this.gridApi.setGridOption('loading', false);
      this.gridApi.deselectAll();
    }
  }

  saveTask(): void {
    return;
  }

  refreshTasksFromEntry(): void {
    this.toggleModal('hide');
    this.gridApi.setGridOption('loading', true);
    this.getUXData(this.userID, "tasks",this.token);
  }

  getUXData(user: string, mode: string, token:string): void {
    const json = { "tasksActive": this.taskForm.taskStatus, "taskType": this.taskForm.taskType };
    this.gridApi.setGridOption('loading', true);

    this.hourglassService.getTimeEntryUxData(user, "all", json,this.token).then(data => {
      this.listTasks = data.tasks;
      this.buildColumnSpec(this.listTasks);
      this.gridApi.setGridOption('rowData', this.listTasks);

      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
        this.gridApi.setGridOption('loading', false);
      })
    }).catch(ex => {
      console.log("Task Grid UXData Catch", ex);
    })
  }

  getTaskData(): void {
    const json = { "tasksActive": this.taskForm.taskStatus };
    this.gridApi.setGridOption('loading', true);
    this.hourglassService.getTimeEntryUxData(this.userID, "tasks", json,this.token).then(r => {
      this.gridApi.setGridOption("rowData", r.tasks);
      this.gridApi.setGridOption('loading', false);
    })
  }

  trackByFn(index: any, record: any) {
    return record.id
  }

  resetFilters(): void {
    this.taskForm.taskStatus = -1;
    this.taskForm.taskSearch = "";
    this.getTaskData();
  }

  buildColumnSpec(table: any): any {
    const tbl = Object.keys(table[0]);
    const labels: any[] = [
      'ID',
      'Task Name',
      'Description',
      'Category ID',
      'Category',
      'Client IDs',
      'Clients',
      'Assignee IDs',
      'Assignees',
      'Owner',
      'Last Used',
      'Active',
      'Team Names'
    ];
    const alignments: any[] = [
      'center',
      'start',
      'start',
      'start',
      'start',
      'start',
      'start',
      'center',
      'start',
      'start',
      'center',
      'center'
    ];
    const widths: any[] = [
      0,
      300,
      300,
      0,
      200,
      0,
      150,
      0,
      250,
      100,
      150,
      75
    ];
    const hides: any[] = ['id','category_id','clientids','assignees'];
    const expanders: any[] = ['t_description'];
    let i = 1;

    this.columnDefs = tbl.map((col) => {
      let returnedColDef = {};
      
      const baseColDef = {
        cellClass: ['text-' + alignments[i-1]],
        field: col,
        headerName: labels[i-1],
        headerTooltip: labels[i-1],
        headerClass: 'text-center',
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        hide: (hides.includes(col)) ? true : false,
        width: widths[i-1],
        tooltipField: col,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: (expanders.includes(col)) ? false : true,
        cellRenderer: this.cellRenderer
      };
            
      returnedColDef = baseColDef;
      i++;
      return returnedColDef;
    })
  }

  cellRenderer(params: any) {
    let template: any = '';
    let tmp: any = '';

    switch (params.colDef.field) {
      case 't_date':
        tmp = params.getValue().replace('T', '');
        template = dayjs(tmp).format("DD-MM-YYYY");
        break;
      case 'active_flag':
        template = (params.getValue() == 1) ? '<i class="fas fa-fw  fa-check c_green"></i>' : '<i class="fas fa-fw fa-times c_red"></i>';
        break;
      case 'last_entry':
        template = (params.getValue() == null) ? '-' : dayjs(new Date(params.getValue())).format("DD-MM-YYYY");
        break;
      default:
        template = params.getValue();
        break;
    }
    return template;
  }

  renderText(params: string): string {
    return [params].join('')
  }

  renderDate(params: string): string {
    const dt = params.replace(/T/g, ' ');
    return dayjs(dt).format('DD/MM/YYYY')
  }

  searchChange(): void {
    const term = this.taskForm.taskSearch;
    this.gridApi.setGridOption('quickFilterText', term);
  }

  onSelectionChanged(event: any) {
    if (event.source != "apiSelectAll") {
      this.gridApi.setGridOption('loading', true);
      this.saveMode = "edit";
      const selectedRows = this.gridApi.getSelectedRows();
      const rowdata: any = selectedRows[0];

      console.log("onSelectionChanged", rowdata)


      $('#taskModal .modal-title').html("<i class='fas fa-fw fa-lg fa-check me-1'></i>Edit Task");

      if (rowdata !== undefined) {
        this.taskForm.taskId = rowdata.id;
        //this.taskForm.dtTask = dayjs(rowdata.t_date).format("YYYY-MM-DD");
        this.taskForm.taskName = rowdata.t_name;
        this.taskForm.taskDescription = rowdata.t_description;
        this.taskForm.category = rowdata.category_id;
        this.taskForm.clients = rowdata.clientids.split(',');
        this.taskForm.assignees = rowdata.assignees.split(',')
        
        sessionStorage.setItem('wOSTask', JSON.stringify(rowdata.id));
        this.gridApi.setGridOption('loading', false);
        this.toggleModal('show');
      }
    }
  }

  renderHeader(params: string) {
    return ["<div class='text-center'><strong>", params, "</strong></div>"].join('')
  }

  saveEntry(): void {
    if (this.taskForm.taskName == '') {
      this.errorMessage = 'Task name is required.';
      this.clearErrorMessage();
      $('#sel_employee').trigger('focus');
      return;
    }

    if (this.taskForm.category == '') {
      this.errorMessage = 'Task category is required.';
      this.clearErrorMessage();
      $('#sel_task').trigger('focus');
      return;
    }

    this.errorMessage = "Saving Task.";
    this.gridApi.setGridOption('loading', true);
    this.taskForm.entity = "entry";
    this.taskForm.mode = this.saveMode;
    
    this.hourglassService.saveTimeEntryEntity(this.taskForm, this.token).then(r => {
      this.getUXData(this.userID, "all", this.token);

      setTimeout(() => {
        this.gridApi.setGridOption('loading', false);
      },1500)
    })
  }

  clearErrorMessage(delay:any = 3500): void {
    setTimeout(() => {
      this.errorMessage = '';
    },delay)
  }
}
